<template>
  <div>
    <div class="d-flex align-center">
      <base-product-rating
        :value="points"
        sm-and-down-small
      ></base-product-rating>
      <span class="px-5 px-md-10 text-body-4 text-md-body-3">
        {{ formattedCreateAt }}
      </span>
    </div>
    <h4 class="mt-3 mt-md-5 text-h5 text-md-h4">
      {{ title }}
    </h4>

    <p class="mt-3 mt-md-4 mb-0 text-body-3 text-md-body-2">
      {{ content }}
    </p>
  </div>
</template>

<script>
import BaseProductRating from '~/components/base/product/rating/BaseProductRating'

export default {
  name: 'ProductReviewCard',
  components: { BaseProductRating },
  props: {
    content: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    points: {
      type: Number,
      required: true,
    },
    createdAt: {
      type: String,
      required: true,
    },
  },

  computed: {
    formattedCreateAt() {
      return this.$d(new Date(this.createdAt), 'short')
    },
  },
}
</script>
